import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import DownloadInvoice from './DownloadInvoice';
import { getDownloadInvoice } from '../../services/store/features/User/actions';
import type { AppDispatch, RootState } from 'services/store/types';

const mapStateToProps = (state: RootState) => ({
  status: state.user.status,
  isOwner: state.user.isOwner,
});

const mapDispatchToProps = (dispatch: AppDispatch) => ({
  actions: bindActionCreators({ getDownloadInvoice }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(DownloadInvoice);
